import { render, staticRenderFns } from "./HygieneTable.vue?vue&type=template&id=4d667535&scoped=true&"
import script from "./HygieneTable.ts?vue&type=script&lang=ts&"
export * from "./HygieneTable.ts?vue&type=script&lang=ts&"
import style0 from "./HygieneTable.scss?vue&type=style&index=0&id=4d667535&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d667535",
  null
  
)

export default component.exports